import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { StaticContext } from 'react-router';
import qs from 'qs';
import LoginComponent from '../../components/auth/LoginComponent';
import { RootState } from '../../modules';
import { loginUserAsync } from '../../modules/auth';
import { Alert, Spin } from 'antd';
type LocationState = {
  from: Location;
};

function LoginContainer({
  history,
}: RouteComponentProps<{}, StaticContext, LocationState>) {
  const { redirectUrl } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  const { data, loading, error } = useSelector(
    (state: RootState) => state.auth.auth,
  );

  useEffect(() => {
    if (!!data) {
      if (!!history.location.state) {
        history.push({
          pathname: `${history.location.state.from}`,
          search: window.location.search,
        });
      } else {
        if (data.isEnabled)
          history.push(`enterprises/${data.myEnterprise.id}/main`);
      }
    }
  }, [history, data, redirectUrl]);
  const dispatch = useDispatch();
  const login = (data: any) => {
    dispatch(loginUserAsync.request(data));
  };

  const createErrorMsg = (error: any) => {
    return error.response.data.message;
  };

  return (
    <>
      {loading && <Spin />}
      {error && (
        <Alert message={createErrorMsg(error)} type="error" showIcon closable />
      )}
      <LoginComponent login={login} />
    </>
  );
}

export default LoginContainer;
